import { AuthForm } from './AuthForm';

export function AuthGate() {
    return (
        <div className="flex items-center justify-center p-4 py-12">
            <div className="max-w-md w-full animate-in fade-in zoom-in-95 duration-500">
                <AuthForm
                    defaultTab="register"
                    title="Sync Required"
                    description="We can only save and access your settings if you sign up."
                />
            </div>
        </div>
    );
}
